'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactToPrint = require('react-to-print');
var ComponentContainer = require('./components/ComponentContainer.js');

var PrintComponentGenerator = function (props) {
    var documentTitle = props.documentTitle, onAfterPrint = props.onAfterPrint, onPrintError = props.onPrintError;
    var printRef = React.useRef(null);
    var handlePrintClick = reactToPrint.useReactToPrint({
        content: function () { return printRef.current; },
        documentTitle: documentTitle,
        onAfterPrint: onAfterPrint,
        onPrintError: onPrintError,
    });
    return {
        handlePrintClick: handlePrintClick,
        ComponentContainer: function (componentProps) {
            var children = componentProps.children;
            return React__default.createElement(ComponentContainer.default, { printRef: printRef }, children);
        },
    };
};

module.exports = PrintComponentGenerator;
